module.exports = __webpack_public_path__ + "static/media/120.8086f288.jpg";